import React from 'react'
import classNames from 'classnames'

import T from 'components/FormattedMessage'
import Currency from 'components/Currency'
import GeneralListItem from 'components/GeneralListItem'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import { WonReferralBonusTypeToken } from 'lib/enumTranslations'
import { IReferralBonus } from 'protos'

import blankUserPhoto from './assets/blank_user.png'

interface Props {
  bonuses: Array<IReferralBonus>
  selectedBonusId?: number
  onBonusSelect: (bonusId: number) => any // tslint:disable-line:no-any
}

const styles = (theme: Theme) => createStyles({
  referralCounter: {
    backgroundColor: theme.palette.grey['500'],
    width: 40,
    height: 40,
    borderRadius: '50%',
    lineHeight: '40px',
    textAlign: 'center',
  },
  selectedReferralCounter: {
    backgroundColor: '#fff',
  },
  referralList: {
    marginLeft: -theme.spacing(),
  },
  referralPhoto: {
    display: 'block',
    width: 40,
    height: 40,
    borderRadius: '50%',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const WonBonusList: React.SFC<InjectedProps> = ({ bonuses, onBonusSelect, selectedBonusId, classes }) => (
  <List>
    <ListItem divider>
      <Typography variant="caption" color="textSecondary">
        <T id="referrals_section_bonus_title" />
      </Typography>
    </ListItem>
    {bonuses.map((bonus, i) => {
      const isSelected = i === selectedBonusId
      const isSelectable = Boolean(bonus.receivedBonus && bonus.receivedBonus.value! > 0)
      return (
        <GeneralListItem
          key={i}
          onClick={isSelectable ? () => onBonusSelect(i) : undefined}
          headline={<T id={WonReferralBonusTypeToken(bonus.type!)} />}
          subtitle={<Currency value={bonus.value && bonus.value.value} />}
          leftChild={(
            <Typography
              variant="body1"
              className={classNames(
                { [classes.selectedReferralCounter]: isSelected },
                classes.referralCounter,
              )}
            >
              {bonus.referral && bonus.referral.length}
            </Typography>
          )}
          rightChild={isSelectable && (
            <Typography variant="subtitle1">
              <Currency value={bonus.receivedBonus!.value} />
            </Typography>
          )}
          button={isSelectable && !isSelected}
          isDropdownActive={isSelected}
          dropdownChild={isSelectable && (
            <List disablePadding className={classes.referralList}>
              {bonus.referral!.map((referral, j) => {
                const bonusElement = <Currency value={referral.nextBonus!.value} />
                const count = Number(referral.nextRemaining)
                const subtitle = count > 1
                  ? (
                    <T
                      id="referrals_nextlevel_gamesremaining_plural"
                      values={{ count, bonus: bonusElement }}
                    />
                  )
                  : (
                    <T
                      id="referrals_nextlevel_gamesremaining_singular"
                      values={{ bonus: bonusElement }}
                    />
                  )

                return (
                  <GeneralListItem
                    key={j}
                    headline={referral.user!.name}
                    subtitle={subtitle}
                    leftChild={(
                      <img alt="" src={blankUserPhoto} className={classes.referralPhoto} />
                    )}
                    subtitleVariant="h3"
                  />
                )
              })}
            </List>
          )}
        />
      )
    })}
  </List>
)

export default withStyles(styles)(WonBonusList)
